import * as AccordionPrimitive from '@radix-ui/react-accordion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AbsenceRow } from '@/components/AbsenceRow';
import { ChevronDown } from '@/components/Icons/ChevronDown';
import type { NonAttendance, NonAttendanceGroup } from '@/types/overview';
import { formatLongDate } from '@/utils/date';

interface Props {
  entry: NonAttendanceGroup;
  value: string;
  onAbsenceClick: (absence: NonAttendance, date: string) => void;
}

export const JustificationDateGroup: React.FC<Props> = ({
  entry,
  value,
  onAbsenceClick,
}) => {
  const { t } = useTranslation();
  const dayCount = entry.nonAttendances.length;

  return (
    <AccordionPrimitive.Item
      value={value}
      className="border-t border-border first:border-t-0"
    >
      <AccordionPrimitive.Header className="flex">
        <AccordionPrimitive.Trigger className="group flex w-full cursor-pointer items-center justify-between gap-3 px-4 py-4 text-left outline-none md:px-5 md:py-6">
          <span className="text-subhead-14 truncate text-foreground">
            {formatLongDate(entry.date)}
          </span>
          <span className="flex shrink-0 items-center gap-2 text-muted-foreground">
            <span className="text-body-13 md:text-body-14">
              {t('home.dashboard.absences.count', { count: dayCount })}
            </span>
            <ChevronDown className="size-4 transition-transform duration-200 group-data-[state=open]:rotate-180" />
          </span>
        </AccordionPrimitive.Trigger>
      </AccordionPrimitive.Header>
      <AccordionPrimitive.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
        <ul className="flex flex-col">
          {entry.nonAttendances.map((absence) => (
            <AbsenceRow
              key={absence.id}
              nonAttendance={absence}
              onClick={() => onAbsenceClick(absence, entry.date)}
            />
          ))}
        </ul>
      </AccordionPrimitive.Content>
    </AccordionPrimitive.Item>
  );
};
